var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "79.8191681px",
    height: "100px",
    viewBox: "0 0 79.8191681 100",
    style: {
      enableBackground: "new 0 0 79.8191681 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Drop_x0020_Shadow{fill:none;}\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\n\t.Dusk{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#44ADE2;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.9811773,
    y1: 0,
    x2: -10.2740726,
    y2: 0.7071093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738151,
    style: {
      stopColor: "#D8D9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352005,
    style: {
      stopColor: "#C9CACD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322592,
    style: {
      stopColor: "#B4B5B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7138845,
    style: {
      stopColor: "#989A9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949245,
    style: {
      stopColor: "#797C7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#656B6C"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8915443,56.3438034 M76.8294373,60.7023087V45.3281212h-1.077446 c0,6.2782021-4.2830429,10.2494583-9.4016266,10.2494583h-7.4037399H48.8915443V4.341248H33.9147301v1.0770631 c3.0218964,0,4.9924316,2.9142494,4.9924316,6.4729376v0.5084057v6.5142536c0,7.3762493,0.0719986,19.0178432-10.9308662,19.425127 c-0.3085594,0.011425-0.6635113,0.0093689-0.9815941-0.0033684c-3.4550629-0.1383286-5.4597187-1.4578896-6.8282452-3.8027191 c-3.8836842-6.654295-1.6840706-19.9432182-1.3635254-22.0050812c1.2978973-8.3485851-3.7353792-8.1866169-3.7353792-8.1866169 H5.0839V5.418469c0,0,5.2982354,0.2247782,4.1534839,6.5726142c-0.2830601,1.5696135-0.592968,2.7576914-0.7131004,3.442359 C7.8498607,19.2772827,4.147768,42.2677956,24.7111149,43.1760445c1.048666,0.0387993,1.9316235,0.0481415,2.8251286,0.0386963 c4.947403-0.0523109,8.7431641-2.0963631,11.3574219-4.7106209v17.0734596h-9.783186 c-3.2562084,0-5.8917465,0.2364044-7.8599129,0.5126419c-2.7485352,0.3857841-5.4078941,0.8539009-8.2107277,2.6001282 c-1.2162113,0.7577286-2.0050783,1.430378-2.9387398,2.4201164c-2.1703119,2.3006668-3.3049345,4.9500656-3.986208,7.5389175 c-0.6768017,2.5718536-1.0316634,5.384346-1.0316634,8.4536057c0,1.2346573,0.143333,3.3192444,0.3517427,4.7180786 c0.2052445,1.3988571,0.5715337,2.7977142,1.0988541,4.1934052c0.5241828,1.3988266,1.2409773,2.731369,2.1472192,3.9912872 c0.9062557,1.2630768,2.0525026,2.387207,3.438714,3.372406c1.3830585,0.9883423,3.0313749,1.7683029,4.9417543,2.346138 c1.9103928,0.5747147,4.1365452,0.8620682,6.6847878,0.8620682c2.2893143,0,4.2881222-0.2399902,5.9901047-0.719986 c1.7019844-0.4799271,3.1355743-1.0420227,4.2976036-1.6861725c1.1620178-0.644165,2.0777397-1.2883301,2.7440071-1.9325104 c0,0,1.7272491-1.566185,2.0967026-3.362915h0.0189476v7.7015839h14.9896278v-1.0775223 c-3.0218964,0-4.9946251-2.825386-4.9914627-7.0250854V61.671711l-0.0002785-1.1024742h0.0129128h27.9249725V60.7023087z  M38.8930931,80.23246c0,0.807663-0.0504723,1.614975-0.1634064,2.4147034 c-0.0761223,0.5390244-0.1689987,1.0109558-0.3130569,1.5899887c-0.259304,1.0262451-0.7821999,2.1357498-1.5921135,3.048317 c-0.8131256,0.9125595-1.9625969,1.5699463-3.4735985,2.2046509c-1.5142059,0.6347046-3.5350132,1.0269394-6.0416012,1.0269394 c-1.9559784,0-3.6225853-0.1107635-5.0634232-0.65802c-1.2124691-0.4605255-2.1743603-0.9739609-3.0926704-1.8825226 c-0.8016052-0.7931061-1.4481354-1.6463852-2.1165714-3.1333008c-0.4467316-0.9937363-0.7221394-1.7718887-0.9640846-3.3181839 c-0.1784229-1.1403275-0.2217026-2.1408081-0.2571087-3.0940018c-0.0380573-1.0245895-0.0320568-1.7464142-0.0207434-2.2781448 c0.0447969-2.1056747,0.2813559-4.8527756,0.7263231-6.6652603c0.441782-1.8125076,1.1428547-3.385025,2.1000328-4.7175751 c0.9603882-1.3293839,2.2152805-2.3777199,3.7646904-3.1355629c1.5494232-0.7610092,3.484581-1.0652504,5.6614361-1.0652504 c1.4405708,0,2.7114716,0.0926895,3.8191109,0.4368782c1.1076412,0.3410187,2.0648212,0.7925873,2.877943,1.3483276 c0.8099251,0.5589027,1.4821892,1.1936073,2.0200005,1.9040642c0.5314178,0.7104797,0.95718,1.449379,1.2709007,2.2229996 c0.3137245,0.7736206,0.5346146,1.5409622,0.6658707,2.3019714c0.1280479,0.7609787,0.19207,2.2084656,0.19207,2.840004V80.23246z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9139ac4486f3a23a03cbf582ab2d62ff.svg";
export { ForwardRef as ReactComponent };